import { useMutation } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { sendToApi } from 'api/client'
import { buildErrorMessage } from 'utils'
import { UseMutationOptions } from 'react-query/types/react/types'

export interface Data {
  options: Array<string>
}

export interface RequestOptions {
  signal?: AbortSignal
}

export interface Variables extends RequestOptions {
  text: string
  generationType: string
}

export type Options = Omit<UseMutationOptions<Data, unknown, Variables>, 'mutationKey' | 'mutationFn'>

export const createTypeAheadOptions = ({ text, generationType }: Variables, options?: RequestOptions) =>
  sendToApi<{ options: Array<string> }>(`/ai-typeahead-options`, {
    method: 'POST',
    body: { text, generation_type: generationType },
    ...options,
  })

export const useCreateAITypeaheadOptions = (options?: Options) => {
  return useMutation<Data, unknown, Variables>(
    'createAITypeaheadOptions',
    async (variables: Variables) => {
      const { signal, ...rest } = variables
      const response = await createTypeAheadOptions(rest, { signal })
      if (response.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error(
          buildErrorMessage(response.data.errors) ||
            'An error occurred! Our team has been notified and we are looking into it.',
        )
      }
      return response.data
    },
    {
      ...options,
    },
  )
}
